import React from 'react';
import { Helmet } from 'react-helmet-async';

export function SEO({ title, description, ogImage, canonicalUrl }) {
  const fullTitle = title
    ? (title.includes('KELFAE LOFTER') ? title : `${title} | KELFAE LOFTER ApS`)
    : 'KELFAE LOFTER ApS | Akustiklofter & Loftløsninger';

  const defaultDescription =
    'KELFAE LOFTER ApS er en specialiseret B2B leverandør af akustiklofter, loftplader, T-skinnesystemer og montagesystemer til arkitekter, entreprenører og virksomheder.';

  const metaDesc = description || defaultDescription;
  const metaImage =
    ogImage ||
    'https://assets.auxodev.dk/assets/6ff16b38-fa18-408f-9a5d-f4f108c00990/aa3-dsc7088-453.jpg';

  return (
    <Helmet>
      <html lang="da-DK" />
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image" content={metaImage} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
}
